import loadable from '@loadable/component'

export const Pager = loadable(() => import('./Pager'))
export type { PagerProps } from './Pager'
